import { z } from 'zod';

import { ESuluContentBlockTypes } from 'types/enums/sulu/EBackendData';

import ZSCBBase from './ZSCBBase';
import ZSuluMedia from './ZSuluMedia';

const ZSCBImage = ZSCBBase.extend({
  type: z.literal(ESuluContentBlockTypes.IMAGE),
  content: ZSuluMedia,
});

export default ZSCBImage;
